module.exports = __webpack_public_path__ + "static/media/hawthorn.27af75a9.svg";